import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-466cca92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-4" }
const _hoisted_2 = { class: "text-2xl font-bold text-center mb-4" }
const _hoisted_3 = { class: "pr-14" }
const _hoisted_4 = { class: "border-separate border-spacing-x-12 border-spacing-y-1" }
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Shift", -1))
const _hoisted_7 = { class: "text-gray-500 text-sm" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-gray-500 text-sm" }
const _hoisted_10 = { class: "text-end" }

import { useI18n } from "vue-i18n";
import Modal from "shared/components/modals/Modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShortcutsModal',
  props: {
  open: {
    type: Boolean,
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();



const isMacos = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: __props.open,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)("analytics.processes.shortcuts.title")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString(_unref(t)("analytics.processes.shortcuts.draw_area")), 1),
                _createElementVNode("td", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(" + "),
                  _createElementVNode("kbd", null, _toDisplayString(_unref(t)("analytics.processes.shortcuts.draw")), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(_unref(t)("analytics.processes.shortcuts.select_multiple")) + " ", 1),
                  _createElementVNode("span", _hoisted_7, " (" + _toDisplayString(_unref(t)("analytics.processes.shortcuts.event")) + ")", 1)
                ]),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("kbd", null, _toDisplayString(isMacos ? "Cmd" : "Ctrl"), 1),
                  _createTextVNode(" + "),
                  _createElementVNode("kbd", null, _toDisplayString(_unref(t)("analytics.processes.shortcuts.click")), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(_unref(t)("analytics.processes.shortcuts.open_context_menu")) + " ", 1),
                  _createElementVNode("span", _hoisted_9, " (" + _toDisplayString(_unref(t)("analytics.processes.shortcuts.resource")) + ")", 1)
                ]),
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("kbd", null, _toDisplayString(_unref(t)("analytics.processes.shortcuts.right_click")), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})